import Vue from 'vue'
import Router from 'vue-router'
import store from '../../static/sotre/index'
import eocs from '../views/eocs/router'
import newpages from '../views/newpages/router'
const zcps = r => require.ensure([], () => r(require('../components/zcps.vue')), 'zcps');
const tree = r => require.ensure([], () => r(require('../components/tree.vue')), 'tree');
const keshi = r => require.ensure([], () => r(require('../components/keshi.vue')), 'keshi');
// 首页
const menu = r => require.ensure([], () => r(require('../components/menu.vue')), 'menu');
const newMenu = r => require.ensure([], () => r(require('../components/newMenu.vue')), 'newMenu');
//查询首页
const queryMenu = r => require.ensure([], () => r(require('../components/queryMenu.vue')), 'queryMenu');

// 注册
const register = r => require.ensure([], () => r(require('../components/register.vue')), 'register');
// 注册
const updataPass = r => require.ensure([], () => r(require('../components/updataPass.vue')), 'updataPass');

const newDeta = r => require.ensure([], () => r(require('../components/newDeta.vue')), 'newDeta');
// 注册
const agin = r => require.ensure([], () => r(require('../components/agin.vue')), 'agin');
const ceshi = r => require.ensure([], () => r(require('../components/ceshi.vue')), 'ceshi');

// 代理单位查询
const agent = r => require.ensure([], () => r(require('../components/agent.vue')), 'agent');
// 大学生就业服务
const college = r => require.ensure([], () => r(require('../components/college.vue')), 'college');
// 职称评介
const review = r => require.ensure([], () => r(require('../components/review.vue')), 'review');
// 党员服务
const member = r => require.ensure([], () => r(require('../components/member.vue')), 'member');


// 首页-简历列表
const home_List = r => require.ensure([], () => r(require('../components/home_List.vue')), 'home_List');
// 首页-简历列表
const home_resumelist = r => require.ensure([], () => r(require('../components/home_resumelist.vue')),
  'home_resumelist');
// 首页-申请岗位列表
const home_objectlist = r => require.ensure([], () => r(require('../components/home_objectlist')), 'home_objectlist');
// 首页-已报名班期开办提醒
const home_tiplist = r => require.ensure([], () => r(require('../components/home_tiplist.vue')), 'home_tiplist');
// 首页-新增简历
const home_addResume = r => require.ensure([], () => r(require('../components/home_addResume')), 'home_addResume');
//行业类别选择页面
const CategotyHome = r => require.ensure([], () => r(require('../components/CategotyHome')), 'CategotyHome');
// 首页-预览简历
const home_JLYL = r => require.ensure([], () => r(require('../components/home_JLYL.vue')), 'home_JLYL');
// 首页-个人信息
const home_GRXX = r => require.ensure([], () => r(require('../components/home_GRXX.vue')), 'home_GRXX');
// 首页-个人信息-基本信息
const home_JBXX = r => require.ensure([], () => r(require('../components/home_JBXX.vue')), 'home_JBXX');
// 首页-个人信息-简历名称
const home_JLMC = r => require.ensure([], () => r(require('../components/home_JLMC.vue')), 'home_JLMC');
// 首页-个人信息-求职意向
const home_QZYX = r => require.ensure([], () => r(require('../components/home_QZYX.vue')), 'home_QZYX');
// 首页-个人信息-交易背景
const home_JYBJ = r => require.ensure([], () => r(require('../components/home_JYBJ.vue')), 'home_JYBJ');
// 首页-个人信息-交易背景
const home_JYBJList = r => require.ensure([], () => r(require('../components/home_JYBJList.vue')), 'home_JYBJList');
// 首页-个人信息-工作经历
const home_GZJLList = r => require.ensure([], () => r(require('../components/home_GZJLList.vue')), 'home_GZJLList');
// 首页-个人信息-工作经历
const home_GZJL_det = r => require.ensure([], () => r(require('../components/home_GZJL_det.vue')), 'home_GZJL_det');
// 首页-个人信息-项目经验
const home_XMJY = r => require.ensure([], () => r(require('../components/home_XMJY.vue')), 'home_XMJY');
// 首页-个人信息-项目经验
const home_XMJY_det = r => require.ensure([], () => r(require('../components/home_XMJY_det.vue')), 'home_XMJY_det');
const Industry = r => require.ensure([], () => r(require('../components/Industry.vue')), 'Industry');
const Category = r => require.ensure([], () => r(require('../components/Category.vue')), 'Category');
// 首页-岗位列表-高级搜索
const IndustryGJ = r => require.ensure([], () => r(require('../components/IndustryGJ.vue')), 'IndustryGJ');
const CategoryGJ = r => require.ensure([], () => r(require('../components/CategoryGJ.vue')), 'CategoryGJ');


// 首页-个人信息-工作经历
const home_ZWPJ = r => require.ensure([], () => r(require('../components/home_ZWPJ.vue')), 'home_ZWPJ');
// 首页-个人信息-工作经历
const home_YLJJ = r => require.ensure([], () => r(require('../components/home_YLJJ.vue')), 'home_YLJJ');
// 首页-个人信息-工作经历
const home_YJZJ = r => require.ensure([], () => r(require('../components/home_YJZJ.vue')), 'home_YJZJ');

// 首页-代理查询-代理单位查询
const agent_DWCX = r => require.ensure([], () => r(require('../components/agent_DWCX.vue')), 'agent_DWCX');
// 首页-代理查询-代理单位查询
const agent_DWCX_det = r => require.ensure([], () => r(require('../components/agent_DWCX_det.vue')), 'agent_DWCX_det');
// 首页-代理查询-档案查询
const agent_DACX = r => require.ensure([], () => r(require('../components/agent_DACX.vue')), 'agent_DACX');
// 首页-代理查询-档案查询
const agent_DACXZC = r => require.ensure([], () => r(require('../components/agent_DACXZC.vue')), 'agent_DACXZC');
// 首页-代理查询-档案查询
const agent_DACXZC_det = r => require.ensure([], () => r(require('../components/agent_DACXZC_det.vue')),
  'agent_DACXZC_det');

// 首页-代理查询-档案查询
const agent_DACX_det = r => require.ensure([], () => r(require('../components/agent_DACX_det.vue')), 'agent_DACX_det');
// 首页-代理查询-集体户口查询
const agent_JTHK = r => require.ensure([], () => r(require('../components/agent_JTHK.vue')), 'agent_JTHK');
// 首页-代理查询-集体户口查询
const agent_JTHK_det = r => require.ensure([], () => r(require('../components/agent_JTHK_det.vue')), 'agent_JTHK_det');
// 首页-代理查询-证明验证
const agent_ZMYZ = r => require.ensure([], () => r(require('../components/agent_ZMYZ.vue')), 'agent_ZMYZ');
// 首页-代理查询-证明验证
const agent_ZMYZ_det = r => require.ensure([], () => r(require('../components/agent_ZMYZ_det.vue')), 'agent_ZMYZ_det');
// 首页-代理查询-证明验证
const agent_ZMCD_det = r => require.ensure([], () => r(require('../components/agent_ZMCD_det.vue')), 'agent_ZMCD_det');
// 首页-代理查询-代缴社保查询
const agent_SBCX = r => require.ensure([], () => r(require('../components/agent_SBCX.vue')), 'agent_SBCX');
// 首页-代理查询-代缴社保查询
const agent_SBCX_det = r => require.ensure([], () => r(require('../components/agent_SBCX_det.vue')), 'agent_SBCX_det');
// 首页-代理查询-代缴社保查询-养老查询
const agent_SBCX_d_det = r => require.ensure([], () => r(require('../components/agent_SBCX_d_det.vue')),
  'agent_SBCX_d_det');
// 首页-代理查询-代理单位开户申报
const agent_DKDWSB = r => require.ensure([], () => r(require('../components/agent_DKDWSB.vue')), 'agent_DKDWSB');
// 首页-代理查询-办理存档手续申报
const agent_CDSXSB = r => require.ensure([], () => r(require('../components/agent_CDSXSB.vue')), 'agent_CDSXSB');
// 首页-代理查询-办理存档手续申报
const agent_CDSXSB_det = r => require.ensure([], () => r(require('../components/agent_CDSXSB_det.vue')),
  'agent_CDSXSB_det');
// 首页-代理查询-办理存档手续申报
const agent_CDSXSB_det1 = r => require.ensure([], () => r(require('../components/agent_CDSXSB_det1.vue')),
  'agent_CDSXSB_det1');
// 首页-代理查询-办理存档手续申报
const agent_CDSXSB_gz = r => require.ensure([], () => r(require('../components/agent_CDSXSB_gz.vue')),
  'agent_CDSXSB_gz');
// 首页-代理查询-办理存档手续申报
const agent_ZCList = r => require.ensure([], () => r(require('../components/agent_ZCList.vue')),
  'agent_ZCList');
// 首页-代理查询-归档手续申报
const agent_GDSXSB = r => require.ensure([], () => r(require('../components/agent_GDSXSB.vue')), 'agent_GDSXSB');
// 首页-代理查询-归档手续申报进度及材料
const agent_GDSXSB_det = r => require.ensure([], () => r(require('../components/agent_GDSXSB_det.vue')),
  'agent_GDSXSB_det');
// 首页-代理查询-归档手续申报进度及材料-工作经历材料
const gd_GZJL = r => require.ensure([], () => r(require('../components/gd_GZJL.vue')), 'gd_GZJL');
// 首页-代理查询-归档手续申报进度及材料-学习材料
const gd_study = r => require.ensure([], () => r(require('../components/gd_study.vue')), 'gd_study');
// 首页-代理查询-归档手续申报进度及材料-职称、职业资格材料（职称/职业资格评审材料）
const gd_ZYZG = r => require.ensure([], () => r(require('../components/gd_ZYZG.vue')), 'gd_ZYZG');
// 首页-代理查询-归档手续申报进度及材料-其他材料
const gd_else = r => require.ensure([], () => r(require('../components/gd_else.vue')), 'gd_else');
// 首页-代理查询-材料归档查询
const agent_CLGDCX = r => require.ensure([], () => r(require('../components/agent_CLGDCX.vue')), 'agent_CLGDCX');
// 首页-代理查询-材料归档查询
const agent_CLGDCX_det = r => require.ensure([], () => r(require('../components/agent_CLGDCX_det.vue')),
  'agent_CLGDCX_det');

// 首页-代理查询-办理存档手续申报
const agent_DAZCSB = r => require.ensure([], () => r(require('../components/agent_DAZCSB.vue')), 'agent_DAZCSB');
// 首页-代理查询-档案转出申报进度查询
const agent_DAZCSBCX = r => require.ensure([], () => r(require('../components/agent_DAZCSBCX.vue')), 'agent_DAZCSBCX');
// 首页-代理查询-档案转出申报进度查询
const agent_DAZCSBCX_det = r => require.ensure([], () => r(require('../components/agent_DAZCSBCX_det.vue')),
  'agent_DAZCSBCX_det');
// 首页-代理查询-档案信息修改申报
const agent_DAXXXGSB = r => require.ensure([], () => r(require('../components/agent_DAXXXGSB.vue')), 'agent_DAXXXGSB');
// 首页-代理查询-开具调档函
const agent_KJDDH = r => require.ensure([], () => r(require('../components/agent_KJDDH.vue')), 'agent_KJDDH');
// 首页-代理查询-开具调档函进度查询
const agent_DDHJDCX = r => require.ensure([], () => r(require('../components/agent_DDHJDCX.vue')), 'agent_DDHJDCX');
// 首页-代理查询-开具调档函进度查询
const agent_DDHJDCX_det = r => require.ensure([], () => r(require('../components/agent_DDHJDCX_det.vue')),
  'agent_DDHJDCX_det');


// 首页-大学生创业-创业证申报
const college_CYZSB = r => require.ensure([], () => r(require('../components/college_CYZSB.vue')), 'college_CYZSB');
// 首页-大学生创业-创业证
const college_CYZ = r => require.ensure([], () => r(require('../components/college_CYZ.vue')), 'college_CYZ');
// 首页-大学生创业-服务咨询
const college_msg = r => require.ensure([], () => r(require('../components/college_msg.vue')), 'college_msg');
// 首页-大学生创业-服务咨询
const college_msg_Det = r => require.ensure([], () => r(require('../components/college_msg_Det.vue')),
  'college_msg_Det');
// 首页-大学生创业-创业证申报
const college_CYZ_det = r => require.ensure([], () => r(require('../components/college_CYZ_det.vue')),
  'college_CYZ_det');
// 首页-大学生创业-创业证申报
const college_CYZ_Qy = r => require.ensure([], () => r(require('../components/college_CYZ_Qy.vue')), 'college_CYZ_Qy');
// 首页-大学生创业-创业证申报
const college_CYZ_Over = r => require.ensure([], () => r(require('../components/college_CYZ_Over.vue')),
  'college_CYZ_Over');
// 首页-大学生创业-优秀创业项目
const college_CYXM_Qy = r => require.ensure([], () => r(require('../components/college_CYXM_Qy.vue')),
  'college_CYXM_Qy');
// 首页-大学生创业-优秀创业项目
const college_CYXM_person = r => require.ensure([], () => r(require('../components/college_CYXM_person.vue')),
  'college_CYXM_person');
// 首页-大学生创业-优秀创业项目
const college_CYXM_addP = r => require.ensure([], () => r(require('../components/college_CYXM_addP.vue')),
  'college_CYXM_addP');
// 首页-大学生创业- 创业大赛
const college_CYDS = r => require.ensure([], () => r(require('../components/college_CYDS.vue')), 'college_CYDS');


// 首页-教育培训
const education = r => require.ensure([], () => r(require('../components/education.vue')), 'education');
// 首页-教育培训-培训班期报名
const education_PXBM = r => require.ensure([], () => r(require('../components/education_PXBM.vue')), 'education_PXBM');
// 首页-教育培训-培训班期报名-详情
const education_KCXQDetail = r => require.ensure([], () => r(require('../components/education_KCXQDetail.vue')),
  'education_KCXQDetail');
// 首页-教育培训-培训班期报名f
const education_PXBMNext = r => require.ensure([], () => r(require('../components/education_PXBMNext.vue')),
  'education_PXBMNext');

// 首页-毕业生就业
const obtain = r => require.ensure([], () => r(require('../components/obtain.vue')), 'obtain');
// 首页-毕业生就业-招聘会预告
const obtain_ZPHYGList = r => require.ensure([], () => r(require('../components/obtain_ZPHYGList.vue')),
  'obtain_ZPHYGList');

// 首页-毕业生就业-招聘会预告线上
const obtain_ZPHYGListLine = r => require.ensure([], () => r(require('../components/obtain_ZPHYGListLine.vue')),
  'obtain_ZPHYGListLine');
// 首页-毕业生就业-招聘会预告-招聘会详情线上
const obtain_ZPHDetailLine = r => require.ensure([], () => r(require('../components/obtain_ZPHDetailLine.vue')),
  'obtain_ZPHDetailLine');

// 首页-毕业生就业-招聘会预告-招聘会详情
const obtain_ZPHDetail = r => require.ensure([], () => r(require('../components/obtain_ZPHDetail.vue')),
  'obtain_ZPHDetail');

// 首页-毕业生就业-热门职位-详情
const obtain_GWXQDetail = r => require.ensure([], () => r(require('../components/obtain_GWXQDetail.vue')),
  'obtain_GWXQDetail');
// 首页-毕业生就业-热门职位搜索
const obtain_ZWSSList = r => require.ensure([], () => r(require('../components/obtain_ZWSSList.vue')),
  'obtain_ZWSSList');
// 首页-毕业生就业-热门职位搜索线上
const obtain_ZWSSListLine = r => require.ensure([], () => r(require('../components/obtain_ZWSSListLine.vue')),
  'obtain_ZWSSListLine');
// 首页-毕业生就业-高级职位搜索页
const obtain_Advanced = r => require.ensure([], () => r(require('../components/obtain_Advanced.vue')),
  'obtain_Advanced');

// 首页-职称评介-初定职称申报
const review_CDZC = r => require.ensure([], () => r(require('../components/review_CDZC.vue')), 'review_CDZC');
// 首页-职称评介-初定职称申报
const review_CDZC_det = r => require.ensure([], () => r(require('../components/review_CDZC_det.vue')),
  'review_CDZC_det');
// 首页-职称评介-资格证书查询
const review_ZGZS = r => require.ensure([], () => r(require('../components/review_ZGZS.vue')), 'review_ZGZS');
// 首页-职称评介-资格证书查询
const review_ZGZS_det = r => require.ensure([], () => r(require('../components/review_ZGZS_det.vue')),
  'review_ZGZS_det');
// 首页-职称评介-资格证书查询
const review_PJZF = r => require.ensure([], () => r(require('../components/review_PJZF.vue')), 'review_PJZF');


// 首页-党员管理-党员信息变更申报
const member_DYXXBG = r => require.ensure([], () => r(require('../components/member_DYXXBG.vue')), 'member_DYXXBG');
// 首页-党员管理-党费交纳
const member_DFJN = r => require.ensure([], () => r(require('../components/member_DFJN.vue')), 'member_DFJN');
//首页-党员管理-党费交纳-上传图片
const member_SCTP = r => require.ensure([], () => r(require('../components/member_SCTP.vue')), 'member_SCTP');
// 首页-党员管理-立即交费
const member_LJJF = r => require.ensure([], () => r(require('../components/member_LJJF.vue')), 'member_LJJF');
// 首页-党员管理-党员转出转入列表
const member_ZCZR = r => require.ensure([], () => r(require('../components/member_ZCZR.vue')), 'member_ZCZR');
// 首页-党员管理-党员转出转入新建
const member_ZCZR_build = r => require.ensure([], () => r(require('../components/member_ZCZR_build.vue')),
  'member_ZCZR_build');
// 首页-党员管理-党员转出转入新建
const member_YBDY = r => require.ensure([], () => r(require('../components/member_YBDY.vue')), 'member_YBDY');
// 首页-党员管理-党员转出转入新建
const member_DYJF = r => require.ensure([], () => r(require('../components/member_DYJF.vue')), 'member_DYJF');
// 首页-党员管理-党员转出转入新建
const member_ZCZRBuild = r => require.ensure([], () => r(require('../components/member_ZCZRBuild.vue')),
  'member_ZCZRBuild');
// 首页-党员管理-党员登录
const member_LOGIN = r => require.ensure([], () => r(require('../components/member_LOGIN.vue')), 'member_LOGIN');
// 首页-党员管理-党组织关系转出
const member_DZZZC = r => require.ensure([], () => r(require('../components/member_DZZZC.vue')), 'member_DZZZC');
// 首页-党员管理-党组织关系转出列表
const member_DZZZCList = r => require.ensure([], () => r(require('../components/member_DZZZCList.vue')),
  'member_DZZZCList');
// 首页-党员管理-困难党员认定申请
const member_KNDYRD = r => require.ensure([], () => r(require('../components/member_KNDYRD.vue')), 'member_KNDYRD');
// 首页-党员管理-困难党员认定申请列表
const member_KNDYRDList = r => require.ensure([], () => r(require('../components/member_KNDYRDList.vue')),
  'member_KNDYRDList');
// 首页-党员管理-在线学习
const member_ZXXX = r => require.ensure([], () => r(require('../components/member_ZXXX.vue')), 'member_ZXXX');
// 首页-党员管理-在线学习详情
const member_ZXXXDetail = r => require.ensure([], () => r(require('../components/member_ZXXXDetail.vue')),
  'member_ZXXXDetail');
// 首页-党员管理-党务活动
const member_DWHD = r => require.ensure([], () => r(require('../components/member_DWHD.vue')), 'member_DWHD');
// 首页-党员管理-党务活动详情
const member_DWHDDetail = r => require.ensure([], () => r(require('../components/member_DWHDDetail.vue')),
  'member_DWHDDetail');
// 首页-党员管理-通知公告
const member_TZGG = r => require.ensure([], () => r(require('../components/member_TZGG.vue')), 'member_TZGG');
// 首页-党员管理-通知公告详情
const member_TZGGDetail = r => require.ensure([], () => r(require('../components/member_TZGGDetail.vue')),
  'member_TZGGDetail');
//首页-党员管理-个人学习活动上传
const member_GRXXHD = r => require.ensure([], () => r(require('../components/member_GRXXHD.vue')),
  'member_GRXXHD');
//首页-党员管理-支付成功
const member_PAY = r => require.ensure([], () => r(require('../components/member_PAY.vue')),
  'member_PAY');


// 存档证明
const prove_CDZM = r => require.ensure([], () => r(require('../components/prove_CDZM.vue')), 'prove_CDZM');
// 学习证明
const prove_XXZM = r => require.ensure([], () => r(require('../components/prove_XXZM.vue')), 'prove_XXZM');
// 工作证明
const prove_GZZM = r => require.ensure([], () => r(require('../components/prove_GZZM.vue')), 'prove_GZZM');
// 就业证联系函
const prove_JYZM = r => require.ensure([], () => r(require('../components/prove_JYZM.vue')), 'prove_JYZM');
// 近期表现
const prove_JQZM = r => require.ensure([], () => r(require('../components/prove_JQZM.vue')), 'prove_JQZM');
// 出生证明
const prove_CSZM = r => require.ensure([], () => r(require('../components/prove_CSZM.vue')), 'prove_CSZM');
// 同意调出证明
const prove_DCZM = r => require.ensure([], () => r(require('../components/prove_DCZM.vue')), 'prove_DCZM');
// 无业证明
const prove_WYZM = r => require.ensure([], () => r(require('../components/prove_WYZM.vue')), 'prove_WYZM');
// 婚育证明
const prove_HYZM = r => require.ensure([], () => r(require('../components/prove_HYZM.vue')), 'prove_HYZM');

const home_List_Det = r => require.ensure([], () => r(require('../components/home_List_Det.vue')), 'home_List_Det');

const phone = r => require.ensure([], () => r(require('../components/phone.vue')), 'phone');


const yuyue_APP = r => require.ensure([], () => r(require('../components/YuYue/yuyue_APP.vue')), 'yuyue_APP');
const applyAppoin = r => require.ensure([], () => r(require('../components/YuYue/applyAppoin.vue')), 'applyAppoin');
const myAppoin = r => require.ensure([], () => r(require('../components/YuYue/myAppoin.vue')), 'myAppoin');
const appoinDetail = r => require.ensure([], () => r(require('../components/YuYue/appoinDetail.vue')), 'appoinDetail');
const noDa = r => require.ensure([], () => r(require('../components/YuYue/noDa.vue')), 'noDa');
const shiyue = r => require.ensure([], () => r(require('../components/YuYue/shiyue.vue')), 'shiyue');
//企业详情
const obtain_CompanyDetails = r => require.ensure([], () => r(require('../components/obtain_CompanyDetails.vue')),
  'obtain_CompanyDetails');

// 我要查询首页
const agent_WYCX = r => require.ensure([], () => r(require('../components/agent_WYCX.vue')), 'agent_WYCX');
// 七彩云页面
const codeYun = r => require.ensure([], () => r(require('../components/codeYun.vue')), 'codeYun');
// 播放
const bofang = r => require.ensure([], () => r(require('../components/bofang.vue')), 'bofang');
const bofang1 = r => require.ensure([], () => r(require('../components/bofang1.vue')), 'bofang1');
// 判断跳转
const pd = r => require.ensure([], () => r(require('../components/pd.vue')), 'pd');
// 详情

const yunDetails = r => require.ensure([], () => r(require('../components/yunDetails.vue')), 'yunDetails');

// 我要预约
//我要预约申请
const yuyue_Apply = r => require.ensure([], () => r(require('../components/WY_YuYue/yuyue_Apply.vue')), 'yuyue_Apply');
// 个人预约yuyue_person
const yuyue_person = r => require.ensure([], () => r(require('../components/WY_YuYue/yuyue_person.vue')),
  'yuyue_person');
//单位预约yuyue_work
const yuyue_work = r => require.ensure([], () => r(require('../components/WY_YuYue/yuyue_work.vue')), 'yuyue_work');
// 预约提示yuyue_tips
const yuyue_tips = r => require.ensure([], () => r(require('../components/WY_YuYue/yuyue_tips.vue')), 'yuyue_tips');
// 预约成功
const yuyue_success = r => require.ensure([], () => r(require('../components/WY_YuYue/yuyue_success.vue')),
  'yuyue_success');
// 单位预约
const yuyue_DW = r => require.ensure([], () => r(require('../components/WY_YuYue/yuyue_DW.vue')), 'yuyue_DW');


//我要预约
const agent_WYYY = r => require.ensure([], () => r(require('../components/agent_WYYY.vue')), 'agent_WYYY');
//我要办理 agent_WYBL
const agent_WYBL = r => require.ensure([], () => r(require('../components/agent_WYBL.vue')), 'agent_WYBL');

//agent_DAZCSBtest
const agent_DAZCSBtest = r => require.ensure([], () => r(require('../components/agent_DAZCSBtest.vue')),
  'agent_DAZCSBtest');

//企业端
//办事大厅首页
const qiye_index = r => require.ensure([], () => r(require('../components/QiYe/qiye_index.vue')), 'qiye_index');

//招聘信息展示
const qiye_recruitmentInfo = r => require.ensure([], () => r(require('../components/QiYe/qiye_recruitmentInfo.vue')),
  'qiye_recruitmentInfo');
//开始招聘
const qiye_recruit = r => require.ensure([], () => r(require('../components/qiye/qiye_recruit.vue')), 'qiye_recruit');
//现场信息
const qiye_siteInfo = r => require.ensure([], () => r(require('../components/qiye/qiye_siteInfo.vue')),
  'qiye_siteInfo');
//面试记录
const qiye_interviewRecord = r => require.ensure([], () => r(require('../components/qiye/qiye_interviewRecord.vue')),
  'qiye_interviewRecord');
const qiye_interviewRecord1 = r => require.ensure([], () => r(require('../components/qiye/qiye_interviewRecord1.vue')),
  'qiye_interviewRecord1');
//问卷调查
const qiye_questionnaire = r => require.ensure([], () => r(require('../components/qiye/qiye_questionnaire.vue')),
  'qiye_questionnaire');

//招聘会预约
const qiye_jobAppointment = r => require.ensure([], () => r(require('../components/qiye/qiye_jobAppointment.vue')),
  'qiye_jobAppointment');
//职位维护
const qiye_positionMaintenance = r => require.ensure([], () => r(require(
  '../components/qiye/qiye_positionMaintenance.vue')), 'qiye_positionMaintenance');
//历史预约
const qiye_historicalAppointment = r => require.ensure([], () => r(require(
  '../components/qiye/qiye_historicalAppointment.vue')), 'qiye_historicalAppointment');

//简历收藏
const qiye_resumeCollection = r => require.ensure([], () => r(require('../components/qiye/qiye_resumeCollection.vue')),
  'qiye_resumeCollection');
//简历下载
const qiye_resumeDownload = r => require.ensure([], () => r(require('../components/qiye/qiye_resumeDownload.vue')),
  'qiye_resumeDownload');
//人才搜索
const qiye_talentSearch = r => require.ensure([], () => r(require('../components/qiye/qiye_talentSearch.vue')),
  'qiye_talentSearch');
//智能推荐
const qiye_intelligentRecommendation = r => require.ensure([], () => r(require(
  '../components/qiye/qiye_intelligentRecommendation.vue')), 'qiye_intelligentRecommendation');
//预约展位
const qiye_bookingBooth = r => require.ensure([], () => r(require('../components/qiye/qiye_bookingBooth.vue')),
  'qiye_bookingBooth');
//新增招聘会职位
const qiye_addPosition = r => require.ensure([], () => r(require('../components/qiye/qiye_addPosition.vue')),
  'qiye_addPosition');
//选择岗位类别
const qiye_jobCategory = r => require.ensure([], () => r(require('../components/qiye/qiye_jobCategory.vue')),
  'qiye_jobCategory');
//招聘详情
const qiye_recruitmentDetails = r => require.ensure([], () => r(require(
  '../components/qiye/qiye_recruitmentDetails.vue')), 'qiye_recruitmentDetails');
//新增网络职位
const qiye_addNetPosition = r => require.ensure([], () => r(require(
  '../components/qiye/qiye_addNetPosition')), 'qiye_addNetPosition');
//选择所学专业
const qiye_majorCategory = r => require.ensure([], () => r(require(
  '../components/qiye/qiye_majorCategory')), 'qiye_majorCategory');
//企业登录
const qiye_agin = r => require.ensure([], () => r(require(
  '../components/qiye/qiye_agin.vue')), 'qiye_agin');

//测试登录获取用户token
const login = r => require.ensure([], () => r(require(
  '../components/login.vue')), 'login');

//测试注册
const registerNew = r => require.ensure([], () => r(require(
  '../components/registerNew.vue')), 'registerNew');

//测试上传图片
const testUpload = r => require.ensure([], () => r(require(
  '../components/login/testUpload.vue')), 'testUpload');

//登录对接统一登录平台页面-获取用户信息
const beginLogin = r => require.ensure([], () => r(require(
  '../components/login/beginLogin.vue')), 'beginLogin');

const beginLogin1 = r => require.ensure([], () => r(require(
  '../components/login/beginLogin1.vue')), 'beginLogin1');

//查询用户没有社保账号-建档页面（完善信息）
const completeInfo = r => require.ensure([], () => r(require(
  '../components/login/completeInfo.vue')), 'completeInfo');

// 新的登录页面
const newLogin = r => require.ensure([], () => r(require(
  '../components/login/newLogin.vue')), 'newLogin');
// 出具证明申报列表页面
const agent_ZMLB = r => require.ensure([], () => r(require(
  '../components/agent_ZMLB.vue')), 'agent_ZMLB');
// agent_ZMLB.vue

// home_fillInfo.vue
// 完善信息页面
const home_fillInfo = r => require.ensure([], () => r(require(
  '../components/home_fillInfo.vue')), 'home_fillInfo');
//空页面
const empty = r => require.ensure([], () => r(require(
  '../components/empty.vue')), 'empty');


//优秀项目查询列表
const college_YXLB = r => require.ensure([], () => r(require(
  '../components/college_YXLB.vue')), 'college_YXLB');
// 优秀项目补充信息
const fillToInfo = r => require.ensure([], () => r(require(
  '../components/goodPro/fillToInfo.vue')), 'fillToInfo');

// 优秀项目个人基本信息
const info = r => require.ensure([], () => r(require(
  '../components/goodPro/info.vue')), 'info');
// 优秀项目申报详情
const detailPro = r => require.ensure([], () => r(require(
  '../components/goodPro/detailPro.vue')), 'detailPro');

// 核心人员详细信息
const personDetail = r => require.ensure([], () => r(require(
  '../components/goodPro/personDetail.vue')), 'personDetail');


// 大赛列表
const comList = r => require.ensure([], () => r(require(
  '../components/competition/comList.vue')), 'comList');

// 大赛详情页面competitionDetail.vue
const competitionDetail = r => require.ensure([], () => r(require(
  '../components/competition/competitionDetail.vue')), 'competitionDetail');

//大赛初赛分赛点附件列表页fileList
const fileList = r => require.ensure([], () => r(require(
  '../components/competition/fileList.vue')), 'fileList');

// 大赛选择学校
const chooseSchool = r => require.ensure([], () => r(require(
  '../components/competition/chooseSchool.vue')), 'chooseSchool');
// 大赛选择行业
const chooseIndustry = r => require.ensure([], () => r(require(
  '../components/competition/chooseIndustry.vue')), 'chooseIndustry');
// 创响江苏competitionCXJS.vue
const competitionCXJS = r => require.ensure([], () => r(require(
  '../components/competition/competitionCXJS.vue')), 'competitionCXJS');
// 网上都市圈
const agent_WSDSQ = r => require.ensure([], () => r(require(
  '../components/onlineCity/都市圈详情.vue')), 'agent_WSDSQ');
// 招聘会详情
const agent_WSDSQ_index = r => require.ensure([], () => r(require(
  '../components/onlineCity/index.vue')), 'agent_WSDSQ_index');
const agent_WSDSQ_Deatil = r => require.ensure([], () => r(require(
  '../components/onlineCity/onlineCityDetail.vue')), 'agent_WSDSQ_Deatil');
const agent_position_Deatil = r => require.ensure([], () => r(require(
  '../components/onlineCity/positionDetail.vue')), 'agent_position_Deatil');
const agent_qiuzhi_Deatil = r => require.ensure([], () => r(require(
  '../components/qiuzhi.vue')), 'agent_qiuzhi_Deatil');
const agent_shiye_Deatil = r => require.ensure([], () => r(require(
  '../components/shiyezhaopin.vue')), 'agent_shiye_Deatil');
const agent_shiye_jiang = r => require.ensure([], () => r(require(
  '../components/competition/jiang.vue')), 'agent_shiye_jiang');
const obtain_employment = r => require.ensure([], () => r(require(
  '../components/就业创业/就业创业列表.vue')), 'obtain_employment');
const major_events = r => require.ensure([], () => r(require(
  '../components/重大活动/重大活动.vue')), 'major_events');
const recruit_news = r => require.ensure([], () => r(require(
  '../components/招聘信息一码通/招聘信息一码通.vue')), 'recruit_news');
const transfer = r => require.ensure([], () => r(require(
  '../components/招聘信息一码通/页面中转.vue')), 'transfer');
const transfers = r => require.ensure([], () => r(require(
  '../components/招聘信息一码通/transfer.vue')), 'transfers');
// const questionnaire = r => require.ensure([], () => r(require(
//   '../components/大学生就业问卷调查推送/大学生问卷调查.vue')), 'questionnaire');
const questionnaire = r => require.ensure([], () => r(require(
  '../views/eocs/dxsdcwj/dxsdcwj.vue')), 'questionnaire');
const questionnaireNew = r => require.ensure([], () => r(require(
  '../views/eocs/sydcb/sydcb.vue')), 'questionnaireNew');
const postPush = r => require.ensure([], () => r(require(
  '../components/大学生就业问卷调查推送/岗位推送结果.vue')), 'postPush');
const businessGuide = r => require.ensure([], () => r(require(
  '../components/首页相关业务/档案服务/业务指南.vue')), 'businessGuide');
const contactFS = r => require.ensure([], () => r(require(
  '../components/首页相关业务/contact/contactFS.vue')), 'contactFS');

const dangAnReserve = r => require.ensure([], () => r(require(
  '../components/档案预约服务/档案预约.vue')), 'dangAnReserve');
const certification = r => require.ensure([], () => r(require(
  '../components/档案预约服务/出具证明.vue')), 'certification');
const readDang = r => require.ensure([], () => r(require(
  '../components/档案预约服务/阅档.vue')), 'readDang');
const myReservation = r => require.ensure([], () => r(require(
  '../components/档案预约服务/预约列表.vue')), 'myReservation');
const arriveFirst = r => require.ensure([], () => r(require(
  '../components/人社服务包/一键通.vue')), 'arriveFirst');
const policy = r => require.ensure([], () => r(require(
  '../components/人社服务包/人社政策.vue')), 'policy');
const policyInfo = r => require.ensure([], () => r(require(
  '../components/人社服务包/政策详情.vue')), 'policyInfo');

const creative = r => require.ensure([], () => r(require(
  '../components/人社服务包/创企政策.vue')), 'creative');
const now = r => require.ensure([], () => r(require(
  '../components/人社服务包/现企政策.vue')), 'now');
const project = r => require.ensure([], () => r(require(
  '../components/人社服务包/工企政策.vue')), 'project');
const eat = r => require.ensure([], () => r(require(
  '../components/人社服务包/餐企政策.vue')), 'eat');
const middle = r => require.ensure([], () => r(require(
  '../components/人社服务包/中企政策.vue')), 'middle');


const arriveFirstQY = r => require.ensure([], () => r(require(
  '../components/人社服务包/企业一键通.vue')), 'arriveFirstQY');


Vue.use(Router)

const router = new Router({

  routes: [
    {
      path: "*",
      name: '404',
      component: () => import("@/components/404"),
      meta: {
        requireAuth: false,
      },
    },
    {
      path: '/award',
      name: 'award',
      component: agent_shiye_jiang,
      meta: {
        title: '各区奖励'
      }
    },
    {
      path: '/completeInfo',
      name: 'completeInfo',
      component: completeInfo,
      meta: {
        title: '完善信息'
      }
    },
    {
      path: '/newLogin',
      name: 'newLogin',
      component: newLogin,
      meta: {
        title: '登录'
      }
    },
    {
      path: '/college_YXLB',
      name: 'college_YXLB',
      component: college_YXLB,
      meta: {
        title: '优秀项目'
      }
    },
    {
      path: '/personDetail',
      name: 'personDetail',
      component: personDetail,
      meta: {
        title: '详细信息'
      }
    },
    {
      path: '/comList',
      name: 'comList',
      component: comList,
      meta: {
        title: '大赛报名'
      }
    },
    {
      path: '/competitionDetail',
      name: 'competitionDetail',
      component: competitionDetail,
      meta: {
        title: '大赛详情'
      }
    },
    {
      path: '/competitionCXJS',
      name: 'competitionCXJS',
      component: competitionCXJS,
      meta: {
        title: '创响江苏'
      }
    },
    {
      path: '/fileList',
      name: 'fileList',
      component: fileList,
      meta: {
        title: '分赛区附件'
      }
    },
    {
      path: '/chooseSchool',
      name: 'chooseSchool',
      component: chooseSchool,
      meta: {
        title: '选择学校'
      }
    },
    {
      path: '/chooseIndustry',
      name: 'chooseIndustry',
      component: chooseIndustry,
      meta: {
        title: '选择行业'
      }
    },
    {
      path: '/fillToInfo',
      name: 'fillToInfo',
      component: fillToInfo,
      meta: {
        title: '填写信息',
        keepAlive: true
      }
    },
    {
      path: '/detailPro',
      name: 'detailPro',
      component: detailPro,
      meta: {
        title: '详情'
      }
    },
    {
      path: '/info',
      name: 'info',
      component: info,
      meta: {
        title: '基本信息'
      }
    },
    {
      path: '/',
      name: 'beginLogin',
      component: beginLogin,
      meta: {
        title: '登录'
      }
    },
    {
      path: '/beginLogin1',
      name: 'beginLogin1',
      component: beginLogin1,
      meta: {
        title: '登录1'
      }
    },
    {
      path: '/agent_ZMLB',
      name: 'agent_ZMLB',
      component: agent_ZMLB,
      meta: {
        title: '出具证明申报列表'
      }
    },
    {
      path: '/home_fillInfo',
      name: 'home_fillInfo',
      component: home_fillInfo,
      meta: {
        title: '完善信息页面'
      }
    },
    {
      path: '/testUpload',
      name: 'testUpload',
      component: testUpload,
      meta: {
        title: '测试上传图片'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        title: '登录'
      }
    },
    {
      path: '/empty',
      name: 'empty',
      component: empty,
      meta: {
        title: '更新提醒'
      }
    },
    {
      path: '/registerNew',
      name: 'registerNew',
      component: registerNew,
      meta: {
        title: '注册'
      }
    },
    {
      path: '/qiye_index',
      name: 'qiye_index',
      component: qiye_index,
      meta: {
        title: '办事大厅'
      }
    },
    {
      path: '/qiye_recruitmentInfo',
      name: 'qiye_recruitmentInfo',
      component: qiye_recruitmentInfo,
      meta: {
        title: '招聘信息展示'
      }
    },
    {
      path: '/qiye_recruit',
      name: 'qiye_recruit',
      component: qiye_recruit,
      meta: {
        title: '开始招聘'
      }
    },
    {
      path: '/qiye_siteInfo',
      name: 'qiye_siteInfo',
      component: qiye_siteInfo,
      meta: {
        title: '现场信息'
      }
    },
    {
      path: '/qiye_interviewRecord',
      name: 'qiye_interviewRecord',
      component: qiye_interviewRecord,
      meta: {
        title: '面试记录'
      }
    },
    {
      path: '/qiye_interviewRecord1',
      name: 'qiye_interviewRecord1',
      component: qiye_interviewRecord1,
      meta: {
        title: '面试记录'
      }
    },
    {
      path: '/qiye_questionnaire',
      name: 'qiye_questionnaire',
      component: qiye_questionnaire,
      meta: {
        title: '问卷调查'
      }
    },

    {
      path: '/qiye_jobAppointment',
      name: 'qiye_jobAppointment',
      component: qiye_jobAppointment,
      meta: {
        title: '招聘会预约'
      }
    },
    {
      path: '/qiye_bookingBooth',
      name: 'qiye_bookingBooth',
      component: qiye_bookingBooth,
      meta: {
        title: '预约展位'
      }
    },
    {
      path: '/qiye_positionMaintenance',
      name: 'qiye_positionMaintenance',
      component: qiye_positionMaintenance,
      meta: {
        title: '职位维护'
      }
    },
    {
      path: '/qiye_historicalAppointment',
      name: 'qiye_historicalAppointment',
      component: qiye_historicalAppointment,
      meta: {
        title: '历史预约'
      }
    },
    {
      path: '/qiye_resumeCollection',
      name: 'qiye_resumeCollection',
      component: qiye_resumeCollection,
      meta: {
        title: '简历收藏',
        // keepAlive: true
      }
    },
    {
      path: '/qiye_resumeDownload',
      name: 'qiye_resumeDownload',
      component: qiye_resumeDownload,
      meta: {
        title: '简历下载'
      }
    },
    {
      path: '/qiye_talentSearch',
      name: 'qiye_talentSearch',
      component: qiye_talentSearch,
      meta: {
        title: '人才搜索',
        keepAlive: true
      }
    },
    {
      path: '/qiye_intelligentRecommendation',
      name: 'qiye_intelligentRecommendation',
      component: qiye_intelligentRecommendation,
      meta: {
        title: '智能推荐'
      }
    },
    {
      path: '/qiye_addPosition',
      name: 'qiye_addPosition',
      component: qiye_addPosition,
      meta: {
        title: '新增招聘会职位',
        keepAlive: true
      }
    },
    {
      path: '/qiye_jobCategory',
      name: 'qiye_jobCategory',
      component: qiye_jobCategory,
      meta: {
        title: '选择岗位类别'
      }
    },
    {
      path: '/qiye_recruitmentDetails',
      name: 'qiye_recruitmentDetails',
      component: qiye_recruitmentDetails,
      meta: {
        title: '招聘详情'
      }
    }, {
      path: '/qiye_addNetPosition',
      name: 'qiye_addNetPosition',
      component: qiye_addNetPosition,
      meta: {
        title: '新增网络职位',
        keepAlive: true
      }
    },
    {
      path: '/qiye_majorCategory',
      name: 'qiye_majorCategory',
      component: qiye_majorCategory,
      meta: {
        title: '选择所学专业',
        keepAlive: true
      }
    },
    {
      path: '/qiye_agin',
      name: 'qiye_agin',
      component: qiye_agin,
      meta: {
        title: '登录'
      }
    },
    // {
    //   path: '/yuyue_APP',
    //   name: 'yuyue_APP',
    //   component: yuyue_APP,
    //   meta: {
    //     title: '我的预约'
    //   },
    // },
    {
      path: '/yuyue_APP',
      name: 'yuyue_APP',
      component: yuyue_APP,
      meta: {
        title: '我的预约'
      },
      children: [{
        path: '/appoinDetail',
        name: 'appoinDetail',
        component: appoinDetail,
        meta: {
          title: '我的预约'
        }
      }, {
        path: '/applyAppoin',
        name: 'applyAppoin',
        component: applyAppoin,
        meta: {
          title: '我的预约'
        }
      }, {
        path: '/myAppoin',
        name: 'myAppoin',
        component: myAppoin,
        meta: {
          title: '我的预约'
        }
      }, {
        path: '/noDa',
        name: 'noDa',
        component: noDa,
        meta: {
          title: '我的预约'
        }
      }, {
        path: '/shiyue',
        name: 'shiyue',
        component: shiyue,
        meta: {
          title: '我的预约'
        }
      }]
    },
    {
      path: '/agin',
      name: 'agin',
      component: agin,
      meta: {
        title: '登录'
      }
    },
    // {
    //   path: '/',
    //   name: 'obtain_ZPHYGList',
    //   component: obtain_ZPHYGList,
    //   meta: {
    //     title: '招聘会预告',
    //     keepAlive: true
    //   }
    // },
    {
      path: '/obtain_CompanyDetails',
      name: 'obtain_CompanyDetails',
      component: obtain_CompanyDetails,
      meta: {
        title: '企业详情'
      },
    },
    {
      path: '/menu',
      name: 'menu',
      component: menu,
      meta: {
        title: '首页'
      }
    }, {
      path: '/zcps',
      name: 'zcps',
      component: zcps,
      meta: {
        title: '职称评审'
      }
    }, {
      path: '/tree',
      name: 'tree',
      component: tree,
      meta: {
        title: '职称评审'
      }
    }, {
      path: '/keshi',
      name: 'keshi',
      component: keshi,
      meta: {
        title: '选择课时'
      }
    },
    {
      path: '/newMenu',
      name: 'newMenu',
      component: newMenu,
      meta: {
        title: '首页',
        keepAlive: false
      }
    },
    {
      path: '/queryMenu',
      name: 'queryMenu',
      component: queryMenu,
      meta: {
        title: '首页',
        keepAlive: true
      }
    },
    {
      path: '/newDeta',
      name: 'newDeta',
      component: newDeta,
      meta: {
        title: '敬请期待'
      }
    },
    {
      path: '/register',
      name: 'register',
      component: register,
      meta: {
        title: '注册'
      }
    },
    {
      path: '/updataPass',
      name: 'updataPass',
      component: updataPass,
      meta: {
        title: '修改密码'
      }
    }, {
      path: '/phone',
      name: 'phone',
      component: phone,
      meta: {
        title: '输入手机号'
      }
    },
    {
      path: '/agent',
      name: 'agent',
      component: agent,
      meta: {
        title: '档案代理'
      }
    },
    {
      path: '/college',
      name: 'college',
      component: college,
      meta: {
        title: '大学生创业'
      }
    },
    {
      path: '/college_CYDS',
      name: 'college_CYDS',
      component: college_CYDS,
      meta: {
        title: '大学生创业大赛'
      }
    },
    {
      path: '/review',
      name: 'review',
      component: review,
      meta: {
        title: '职称评介'
      }
    },
    {
      path: '/member',
      name: 'member',
      component: member,
      meta: {
        title: '党员管理'
      }
    },

    {
      path: '/home_List',
      name: 'home_List',
      component: home_List,
      meta: {
        title: '个人中心'
      }
    },

    {
      path: '/home_resumelist',
      name: 'home_resumelist',
      component: home_resumelist,
      meta: {
        title: '简历列表'
      }
    },
    {
      path: '/home_objectlist',
      name: 'home_objectlist',
      component: home_objectlist,
      meta: {
        title: '申请岗位列表'
      }
    },
    {
      path: '/home_tiplist',
      name: 'home_tiplist',
      component: home_tiplist,
      meta: {
        title: '已报名班期开办提醒'
      }
    },
    {
      path: '/home_addResume',
      name: 'home_addResume',
      component: home_addResume,
      meta: {
        title: '新增简历',
        keepAlive: true
      }
    },
    {
      path: '/CategotyHome',
      name: 'CategotyHome',
      component: CategotyHome,
      meta: {
        title: '选择行业类别'
      }
    },

    {
      path: '/home_JLYL',
      name: 'home_JLYL',
      component: home_JLYL,
      meta: {
        title: '简历预览'
      }
    },
    {
      path: '/home_GRXX',
      name: 'home_GRXX',
      component: home_GRXX,
      meta: {
        title: '个人信息'
      }
    },
    {
      path: '/home_JBXX',
      name: 'home_JBXX',
      component: home_JBXX,
      meta: {
        title: '基本信息'
      }
    },
    {
      path: '/home_JLMC',
      name: 'home_JLMC',
      component: home_JLMC,
      meta: {
        title: '简历名称',
        // keepAlive:true
      }
    },
    {
      path: '/home_QZYX',
      name: 'home_QZYX',
      component: home_QZYX,
      meta: {
        title: '求职意向',
        keepAlive: true
      }
    },
    {
      path: '/home_JYBJ',
      name: 'home_JYBJ',
      component: home_JYBJ,
      meta: {
        title: '教育背景',
        // keepAlive:true
      }
    },
    {
      path: '/home_JYBJList',
      name: 'home_JYBJList',
      component: home_JYBJList,
      meta: {
        title: '教育背景'
      }
    },
    {
      path: '/home_GZJLList',
      name: 'home_GZJLList',
      component: home_GZJLList,
      meta: {
        title: '工作经历'
      }
    },
    {
      path: '/home_GZJL_det',
      name: 'home_GZJL_det',
      component: home_GZJL_det,
      meta: {
        title: '工作/实习经历',
        keepAlive: true
      }
    },
    {
      path: '/home_XMJY',
      name: 'home_XMJY',
      component: home_XMJY,
      meta: {
        title: '项目经验'
      }
    },
    {
      path: '/home_XMJY_det',
      name: 'home_XMJY_det',
      component: home_XMJY_det,
      meta: {
        title: '项目经验',
        // keepAlive:true
      }
    },
    {
      path: '/Industry',
      name: 'Industry',
      component: Industry,
      meta: {
        title: '职位类别'
      }
    },
    {
      path: '/IndustryGJ',
      name: 'IndustryGJ',
      component: IndustryGJ,
      meta: {
        title: '职位类别'
      }
    },
    {
      path: '/Category',
      name: 'Category',
      component: Category,
      meta: {
        title: '行业类别'
      }
    },
    {
      path: '/CategoryGJ',
      name: 'CategoryGJ',
      component: CategoryGJ,
      meta: {
        title: '行业类别'
      }
    },
    {
      path: '/home_ZWPJ',
      name: 'home_ZWPJ',
      component: home_ZWPJ,
      meta: {
        title: '自我评价'
      }
    },
    {
      path: '/home_YJZJ',
      name: 'home_YJZJ',
      component: home_YJZJ,
      meta: {
        title: '意见征集'
      }
    },
    {
      path: '/home_YLJJ',
      name: 'home_YLJJ',
      component: home_YLJJ,
      meta: {
        title: '预览简历'
      }
    },

    {
      path: '/agent_DWCX',
      name: 'agent_DWCX',
      component: agent_DWCX,
      meta: {
        title: '代理单位查询'
      }
    },
    {
      path: '/agent_DWCX_det',
      name: 'agent_DWCX_det',
      component: agent_DWCX_det,
      meta: {
        title: '代理单位查询'
      }
    },
    {
      path: '/agent_DACX',
      name: 'agent_DACX',
      component: agent_DACX,
      meta: {
        title: '档案查询'
      }
    },
    {
      path: '/agent_DACXZC',
      name: 'agent_DACXZC',
      component: agent_DACXZC,
      meta: {
        title: '档案转出查询'
      }
    },
    {
      path: '/agent_DACXZC_det',
      name: 'agent_DACXZC_det',
      component: agent_DACXZC_det,
      meta: {
        title: '档案转出查询'
      }
    },
    {
      path: '/agent_DACX_det',
      name: 'agent_DACX_det',
      component: agent_DACX_det,
      meta: {
        title: '档案查询'
      }
    },
    {
      path: '/agent_JTHK',
      name: 'agent_JTHK',
      component: agent_JTHK,
      meta: {
        title: '集体户口查询'
      }
    },
    {
      path: '/agent_JTHK_det',
      name: 'agent_JTHK_det',
      component: agent_JTHK_det,
      meta: {
        title: '集体户口查询'
      }
    },
    {
      path: '/agent_ZMYZ',
      name: 'agent_ZMYZ',
      component: agent_ZMYZ,
      meta: {
        title: '证明验证'
      }
    },
    {
      path: '/agent_ZMYZ_det',
      name: 'agent_ZMYZ_det',
      component: agent_ZMYZ_det,
      meta: {
        title: '开具网上证明申报'
      }
    },
    {
      path: '/agent_ZMCD_det',
      name: 'agent_ZMCD_det',
      component: agent_ZMCD_det,
      meta: {
        title: '开具网上证明申报'
      }
    },
    {
      path: '/agent_SBCX',
      name: 'agent_SBCX',
      component: agent_SBCX,
      meta: {
        title: '代缴社保查询'
      }
    },
    {
      path: '/agent_SBCX_det',
      name: 'agent_SBCX_det',
      component: agent_SBCX_det,
      meta: {
        title: '代缴社保查询'
      }
    },
    {
      path: '/agent_SBCX_d_det',
      name: 'agent_SBCX_d_det',
      component: agent_SBCX_d_det,
      meta: {
        title: '代缴社保查询'
      }
    },
    {
      path: '/agent_DKDWSB',
      name: 'agent_DKDWSB',
      component: agent_DKDWSB,
      meta: {
        title: '代理单位开户申报'
      }
    },
    {
      path: '/agent_CDSXSB',
      name: 'agent_CDSXSB',
      component: agent_CDSXSB,
      meta: {
        title: '办理存档手续申报'
      }
    },
    {
      path: '/agent_CDSXSB_det',
      name: 'agent_CDSXSB_det',
      component: agent_CDSXSB_det,
      meta: {
        title: '办理存档手续申报'
      }
    },
    {
      path: '/agent_CDSXSB_det1',
      name: 'agent_CDSXSB_det1',
      component: agent_CDSXSB_det1,
      meta: {
        title: '办理存档手续申报'
      }
    },
    {
      path: '/agent_CDSXSB_gz',
      name: 'agent_CDSXSB_gz',
      component: agent_CDSXSB_gz,
      meta: {
        title: '办理存档手续申报'
      }
    },
    {
      path: '/agent_ZCList',
      name: 'agent_ZCList',
      component: agent_ZCList,
      meta: {
        title: '职称列表'
      }
    },
    {
      path: '/agent_GDSXSB',
      name: 'agent_GDSXSB',
      component: agent_GDSXSB,
      meta: {
        title: '归档手续申报'
      }
    },
    {
      path: '/agent_GDSXSB_det',
      name: 'agent_GDSXSB_det',
      component: agent_GDSXSB_det,
      meta: {
        title: '归档手续申报'
      }
    },
    {
      path: '/gd_GZJL',
      name: 'gd_GZJL',
      component: gd_GZJL,
      meta: {
        title: '工作经历材料'
      }
    },
    {
      path: '/gd_study',
      name: 'gd_study',
      component: gd_study,
      meta: {
        title: '学习材料'
      }
    },
    {
      path: '/gd_ZYZG',
      name: 'gd_ZYZG',
      component: gd_ZYZG,
      meta: {
        title: '职称、职业资格材料'
      }
    },
    {
      path: '/gd_else',
      name: 'gd_else',
      component: gd_else,
      meta: {
        title: '其他材料'
      }
    },
    {
      path: '/agent_CLGDCX',
      name: 'agent_CLGDCX',
      component: agent_CLGDCX,
      meta: {
        title: '其他材料'
      }
    },
    {
      path: '/agent_CLGDCX_det',
      name: 'agent_CLGDCX_det',
      component: agent_CLGDCX_det,
      meta: {
        title: '材料归档查询'
      }
    },
    {
      path: '/agent_DAZCSB',
      name: 'agent_DAZCSB',
      component: agent_DAZCSB,
      meta: {
        title: '档案转出申报'
      }
    },
    {
      path: '/agent_DAZCSBtest',
      name: 'agent_DAZCSBtest',
      component: agent_DAZCSBtest,
      meta: {
        title: '档案转出申报'
      }
    },
    {
      path: '/agent_DAZCSBCX',
      name: 'agent_DAZCSBCX',
      component: agent_DAZCSBCX,
      meta: {
        title: '档案转出申报进度查询'
      }
    },
    {
      path: '/agent_DAZCSBCX_det',
      name: 'agent_DAZCSBCX_det',
      component: agent_DAZCSBCX_det,
      meta: {
        title: '档案转出申报进度查询'
      }
    },
    {
      path: '/agent_KJDDH',
      name: 'agent_KJDDH',
      component: agent_KJDDH,
      meta: {
        title: '开具调档函'
      }
    },
    {
      path: '/agent_DDHJDCX',
      name: 'agent_DDHJDCX',
      component: agent_DDHJDCX,
      meta: {
        title: '开具调档函进度查询'
      }
    },
    {
      path: '/agent_DDHJDCX_det',
      name: 'agent_DDHJDCX_det',
      component: agent_DDHJDCX_det,
      meta: {
        title: '开具调档函进度查询'
      }
    },
    {
      path: '/agent_DAXXXGSB',
      name: 'agent_DAXXXGSB',
      component: agent_DAXXXGSB,
      meta: {
        title: '档案信息修改申报'
      }
    },
    {
      path: '/college_CYZSB',
      name: 'college_CYZSB',
      component: college_CYZSB,
      meta: {
        title: '大学生创业证申报'
      }
    },
    {
      path: '/college_CYZ',
      name: 'college_CYZ',
      component: college_CYZ,
      meta: {
        title: '创业证'
      }
    },
    {
      path: '/college_msg',
      name: 'college_msg',
      component: college_msg,
      meta: {
        title: '创业服务/咨询'
      }
    },
    {
      path: '/college_msg_Det',
      name: 'college_msg_Det',
      component: college_msg_Det,
      meta: {
        title: '创业服务/咨询'
      }
    },
    {
      path: '/college_CYZ_det',
      name: 'college_CYZ_det',
      component: college_CYZ_det,
      meta: {
        title: '大学生创业证申报'
      }
    },
    {
      path: '/college_CYZ_Qy',
      name: 'college_CYZ_Qy',
      component: college_CYZ_Qy,
      meta: {
        title: '大学生创业证申报'
      }
    },
    {
      path: '/college_CYZ_Over',
      name: 'college_CYZ_Over',
      component: college_CYZ_Over,
      meta: {
        title: '大学生创业证申报'
      }
    },
    {
      path: '/college_CYXM_Qy',
      name: 'college_CYXM_Qy',
      component: college_CYXM_Qy,
      meta: {
        title: '优秀创业项目申报',
        keepAlive: true
      }
    },
    {
      path: '/college_CYXM_person',
      name: 'college_CYXM_person',
      component: college_CYXM_person,
      meta: {
        title: '优秀创业项目申报'
      }
    },
    {
      path: '/college_CYXM_addP',
      name: 'college_CYXM_addP',
      component: college_CYXM_addP,
      meta: {
        title: '优秀创业项目申报',
        keepAlive: true
      }
    },
    {
      path: '/education',
      name: 'education',
      component: education,
      meta: {
        title: '教育培训'
      }
    },
    {
      path: '/education_PXBM',
      name: 'education_PXBM',
      component: education_PXBM,
      meta: {
        title: '培训班期报名',
        //keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/education_KCXQDetail',
      name: 'education_KCXQDetail',
      component: education_KCXQDetail,
      meta: {
        title: '培训班期报名'
      }
    },
    {
      path: '/education_PXBMNext',
      name: 'education_PXBMNext',
      component: education_PXBMNext,
      meta: {
        title: '培训班期报名'
      }
    },

    {
      path: '/obtain',
      name: 'obtain',
      component: obtain,
      meta: {
        title: '毕业生就业'
      }
    },
    {
      path: '/obtain_ZPHYGList',
      name: 'obtain_ZPHYGList',
      component: obtain_ZPHYGList,
      meta: {
        title: '线下招聘会',
        //keepAlive: true
      }
    },
    {
      path: '/obtain_ZPHYGListLine',
      name: 'obtain_ZPHYGListLine',
      component: obtain_ZPHYGListLine,
      meta: {
        title: '线上招聘会',
        //keepAlive: true
      }
    },
    {
      path: '/obtain_ZPHDetail',
      name: 'obtain_ZPHDetail',
      component: obtain_ZPHDetail,
      meta: {
        title: '招聘会详情'
      }
    },
    {
      path: '/obtain_ZPHDetailLine',
      name: 'obtain_ZPHDetailLine',
      component: obtain_ZPHDetailLine,
      meta: {
        title: '线上招聘会详情',
        //keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/obtain_ZWSSList',
      name: 'obtain_ZWSSList',
      component: obtain_ZWSSList,
      meta: {
        title: '热门职位搜索',
        //keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/obtain_ZWSSListLine',
      name: 'obtain_ZWSSListLine',
      component: obtain_ZWSSListLine,
      meta: {
        title: '线上热门职位搜索',
        //keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/obtain_Advanced',
      name: 'obtain_Advanced',
      component: obtain_Advanced,
      meta: {
        title: '高级职位搜索',
        keepAlive: true
      }
    },
    {
      path: '/obtain_GWXQDetail',
      name: 'obtain_GWXQDetail',
      component: obtain_GWXQDetail,
      meta: {
        title: '热门职位详情',
      }
    },
    {
      path: '/review_CDZC',
      name: 'review_CDZC',
      component: review_CDZC,
      meta: {
        title: '初定职称申报'
      }
    },
    {
      path: '/review_CDZC_det',
      name: 'review_CDZC_det',
      component: review_CDZC_det,
      meta: {
        title: '初定职称申报'
      }
    },
    {
      path: '/review_ZGZS',
      name: 'review_ZGZS',
      component: review_ZGZS,
      meta: {
        title: '资格证书查询'
      }
    },
    {
      path: '/review_ZGZS_det',
      name: 'review_ZGZS_det',
      component: review_ZGZS_det,
      meta: {
        title: '资格证书查询详情'
      }
    },
    {
      path: '/review_PJZF',
      name: 'review_PJZF',
      component: review_PJZF,
      meta: {
        title: '评审费在线支付'
      }
    },

    {
      path: '/member_DYXXBG',
      name: 'member_DYXXBG',
      component: member_DYXXBG,
      meta: {
        title: '党员信息变更申请'
      }
    },
    {
      path: '/member_DFJN',
      name: 'member_DFJN',
      component: member_DFJN,
      meta: {
        title: '历史党费交纳情况'
      }
    },
    {
      path: '/member_ZCZR',
      name: 'member_ZCZR',
      component: member_ZCZR,
      meta: {
        title: '党组织关系转出/准入'
      }
    },
    {
      path: '/member_ZCZR_build',
      name: 'member_ZCZR_build',
      component: member_ZCZR_build,
      meta: {
        title: '党组织关系转出/准入'
      }
    },
    {
      path: '/member_YBDY',
      name: 'member_YBDY',
      component: member_YBDY,
      meta: {
        title: '预备党员转正业务办理进度进程'
      }
    },
    {
      path: '/member_DYJF',
      name: 'member_DYJF',
      component: member_DYJF,
      meta: {
        title: '在线交纳党费'
      }
    },
    {
      path: '/member_SCTP',
      name: 'member_SCTP',
      component: member_SCTP,
      meta: {
        title: '上传党费交纳记录'
      }
    },
    {
      path: '/member_LJJF',
      name: 'member_LJJF',
      component: member_LJJF,
      meta: {
        title: '立即交费'
      }
    },
    {
      path: '/member_DZZZC',
      name: 'member_DZZZC',
      component: member_DZZZC,
      meta: {
        title: '党组织关系转出'
      }
    },
    {
      path: '/member_DZZZCList',
      name: 'member_DZZZCList',
      component: member_DZZZCList,
      meta: {
        title: '党组织关系转出列表'
      }
    },
    {
      path: '/member_ZCZRBuild',
      name: 'member_ZCZRBuild',
      component: member_ZCZRBuild,
      meta: {
        title: '党组织关系转入转出'
      }
    },
    {
      path: '/member_KNDYRD',
      name: 'member_KNDYRD',
      component: member_KNDYRD,
      meta: {
        title: '困难党员认定申请'
      }
    },
    {
      path: '/member_KNDYRDList',
      name: 'member_KNDYRDList',
      component: member_KNDYRDList,
      meta: {
        title: '困难党员认定申请列表'
      }
    },
    {
      path: '/member_ZXXX',
      name: 'member_ZXXX',
      component: member_ZXXX,
      meta: {
        title: '在线学习'
      }
    },
    {
      path: '/member_ZXXXDetail',
      name: 'member_ZXXXDetail',
      component: member_ZXXXDetail,
      meta: {
        title: '详情'
      }
    },
    {
      path: '/member_DWHD',
      name: 'member_DWHD',
      component: member_DWHD,
      meta: {
        title: '党务活动'
      }
    },
    {
      path: '/member_DWHDDetail',
      name: 'member_DWHDDetail',
      component: member_DWHDDetail,
      meta: {
        title: '详情'
      }
    },
    {
      path: '/member_TZGG',
      name: 'member_TZGG',
      component: member_TZGG,
      meta: {
        title: '通知公告'
      }
    },
    {
      path: '/member_TZGGDetail',
      name: 'member_TZGGDetail',
      component: member_TZGGDetail,
      meta: {
        title: '详情'
      }
    },
    {
      path: '/member_LOGIN',
      name: 'member_LOGIN',
      component: member_LOGIN,
      meta: {
        title: '党员登录'
      }
    },
    {
      path: '/member_GRXXHD',
      name: 'member_GRXXHD',
      component: member_GRXXHD,
      meta: {
        title: '个人学习活动'
      }
    },
    {
      path: '/member_PAY',
      name: 'member_PAY',
      component: member_PAY,
      meta: {
        title: '支付'
      }
    },
    {
      path: '/ceshi',
      name: 'ceshi',
      component: ceshi,
      meta: {
        title: '办事指南'
      }
    },
    {
      path: '/prove_CDZM',
      name: 'prove_CDZM',
      component: prove_CDZM,
      meta: {
        title: '存档证明'
      }
    }, {
      path: '/prove_XXZM',
      name: 'prove_XXZM',
      component: prove_XXZM,
      meta: {
        title: '学习经历证明'
      }
    }, {
      path: '/prove_GZZM',
      name: 'prove_GZZM',
      component: prove_GZZM,
      meta: {
        title: '工作经历证明'
      }
    }, {
      path: '/prove_JYZM',
      name: 'prove_JYZM',
      component: prove_JYZM,
      meta: {
        title: '就业证联系函'
      }
    }, {
      path: '/prove_JQZM',
      name: 'prove_JQZM',
      component: prove_JQZM,
      meta: {
        title: '近期表现'
      }
    }, {
      path: '/prove_CSZM',
      name: 'prove_CSZM',
      component: prove_CSZM,
      meta: {
        title: '出生证明'
      }
    }, {
      path: '/prove_DCZM',
      name: 'prove_DCZM',
      component: prove_DCZM,
      meta: {
        title: '同意调出证明'
      }
    }, {
      path: '/prove_WYZM',
      name: 'prove_WYZM',
      component: prove_WYZM,
      meta: {
        title: '无业证明'
      }
    }, {
      path: '/prove_HYZM',
      name: 'prove_HYZM',
      component: prove_HYZM,
      meta: {
        title: '婚育证明'
      }
    }, {
      path: '/home_List_Det',
      name: 'home_List_Det',
      component: home_List_Det,
      meta: {
        title: '班期详情'
      }
    },
    {
      path: '/agent_WYCX',
      name: 'agent_WYCX',
      component: agent_WYCX,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/codeYun',
      name: 'codeYun',
      component: codeYun,
      meta: {
        title: '七彩云'
      }
    },
    {
      path: '/bofang',
      name: 'bofang',
      component: bofang,
      meta: {
        title: '播放'
      }
    },
    {
      path: '/bofang1',
      name: 'bofang1',
      component: bofang1,
      meta: {
        title: '播放'
      }
    },
    {
      path: '/pd',
      name: 'pd',
      component: pd,
      meta: {
        title: '跳转'
      }
    },
    {
      path: '/yunDetails',
      name: 'yunDetails',
      component: yunDetails,
      meta: {
        title: '详情'
      }
    },
    // 我要预约yuyue_Apply
    {
      path: '/yuyue_Apply',
      name: 'yuyue_Apply',
      component: yuyue_Apply,
      meta: {
        title: '我的预约'
      },
    },
    {
      path: '/yuyue_person',
      name: 'yuyue_person',
      component: yuyue_person,
      meta: {
        title: '个人预约',
      }
    },
    {
      path: '/yuyue_work',
      name: 'yuyue_work',
      component: yuyue_work,
      meta: {
        title: '单位预约'
      }
    },
    {
      path: '/yuyue_tips',
      name: 'yuyue_tips',
      component: yuyue_tips,
      meta: {
        title: '预约提示'
      }
    },
    {
      path: '/yuyue_success',
      name: 'yuyue_success',
      component: yuyue_success,
      meta: {
        title: '预约成功'
      }
    },
    {
      path: '/yuyue_DW',
      name: 'yuyue_DW',
      component: yuyue_DW,
      meta: {
        title: '单位预约'
      }
    },
    {
      path: '/agent_WYYY',
      name: 'agent_WYYY',
      component: agent_WYYY,
      meta: {
        title: '我要预约'
      }
    },
    {
      path: '/agent_WYBL',
      name: 'agent_WYBL',
      component: agent_WYBL,
      meta: {
        title: '我要办理'
      }
    },
    {
      path: '/cityindex',
      name: 'CityIndex',
      component: agent_WSDSQ_index,
      meta: {
        title: '南京都市圈招聘信息'
      }
    },
    {
      path: '/cooperateNH',
      name: 'cooperateNH',
      component: () => import("@/components/onlineCity/宁淮合作专区.vue"),
      meta: {
        title: '宁淮合作专区'
      }
    },
    {
      path: '/newsListNH',
      name: 'newsListNH',
      component: () => import("@/components/onlineCity/淮安新闻列表.vue"),
      meta: {
        title: '就业政策'
      }
    },
    {
      path: '/onlineCityIndex',
      name: 'onlineCityIndex',
      component: agent_WSDSQ,
      meta: {
        title: ''
      }
    },
    {
      path: '/onlineCityDetail',
      name: 'onlineCityDetail',
      component: agent_WSDSQ_Deatil,
      meta: {
        title: '招聘会详情'
      }
    },
    {
      path: '/positionDetail',
      name: 'positionDetail',
      component: agent_position_Deatil,
      meta: {
        title: '岗位详情'
      }
    },
    {
      path: '/qiuzhi',
      name: 'qiuzhi',
      component: agent_qiuzhi_Deatil,
      meta: {
        title: '求职单'
      }
    },
    {
      path: '/shiye',
      name: 'shiye',
      component: agent_shiye_Deatil,
      meta: {
        title: '事业单位招聘'
      }
    },
    {
      path: '/obtainEmployment',
      name: 'obtainEmployment',
      component: obtain_employment,
      meta: {
        title: '就业创业政策'
      }
    },
    {
      path: '/majorEvents',
      name: 'majorEvents',
      component: major_events,
      meta: {
        title: '重大活动报道'
      }
    },
    {
      path: '/recruitNews',
      name: 'recruitNews',
      component: recruit_news,
      meta: {
        title: '招聘信息,一码通览'
      }
    }, {
      path: '/transfer',
      name: 'transfer',
      component: transfer,
      meta: {
        title: '高校毕业生'
      }
    }, {
      path: '/transfers',
      name: 'transfers',
      component: transfers,
      meta: {
        title: '高校毕业生'
      }
    }, {
      path: '/questionnaire',
      name: 'questionnaire',
      component: questionnaire,
      meta: {
        title: '调查问卷'
      }
    },
    {
      path: '/questionnaireNew',
      name: 'questionnaireNew',
      component: questionnaireNew,
      meta: {
        title: '调查问卷'
      }
    },
    {
      path: '/postPush',
      name: 'postPush',
      component: postPush,
      meta: {
        title: '匹配结果'
      }
    },
    {
      path: '/businessGuide',
      name: 'businessGuide',
      component: businessGuide,
      meta: {
        title: '业务指南'
      }
    },
    {
      path: '/contactFS',
      name: 'contactFS',
      component: contactFS,
      meta: {
        title: '联系方式'
      }
    },
    {
      path: '/postPushView',
      name: 'postPushView',
      component: () => import("@/components/大学生就业问卷调查推送/view"),
      meta: {
        title: '匹配结果详情'
      }
    },
    {
      path: '/collegeRecruitment',
      name: 'collegeRecruitment',
      component: () => import("@/components/招聘信息一码通/大学生招聘"),
      meta: {
        title: '大学生招聘'
      }
    },
    {
      path: '/questionnaireApp',
      name: 'questionnaireApp',
      component: () => import("@/components/大学生就业问卷调查推送/对接南京大学生版中转"),
      meta: {
        title: '对接问需'
      }
    },
    // {
    //   path: '/questionnaireWXApp',
    //   name: 'questionnaireWXApp',
    //   component: () => import("@/components/大学生就业问卷调查推送/大学生调查问卷对接大学生版"),
    //   meta: {
    //     title: '对接问需'
    //   }
    // },
    {
      path: '/questionnaireWXApp',
      name: 'questionnaireWXApp',
      component: () => import("@/views/eocs/dxsdcwj/dxsdcwj.vue"),
      meta: {
        title: '对接问需'
      }
    },
    {
      path: '/collegeRecruitmentAPP',
      name: 'collegeRecruitmentAPP',
      component: () => import("@/components/招聘信息一码通/大学生招聘对接南京大学生版"),
      meta: {
        title: '大学生招聘'
      }
    },
    {
      path: '/lackTalentCity',
      name: 'lackTalentCity',
      component: () => import("@/components/紧缺人才目录/紧缺人才目录城市"),
      meta: {
        title: '紧缺人才目录'
      }
    },
    {
      path: '/talentHomePage',
      name: 'talentHomePage',
      component: () => import("@/components/紧缺人才目录/紧缺人才目录首页"),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/jobHuntingArea',
      name: 'jobHuntingArea',
      component: () => import("@/components/求职招聘/求职招聘专区"),
      meta: {
        title: '求职招聘专区'
      }
    },
    {
      path: '/jobHuntingzz',
      name: 'jobHuntingzz',
      component: () => import("@/components/求职招聘/微信授权中转"),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/postRetrieval',
      name: 'postRetrieval',
      component: () => import("@/components/紧缺人才目录/岗位查询检索"),
      meta: {
        title: '紧缺人才需求目录速查'
      }
    },
    {
      path: '/postRetrievalbf',
      name: 'postRetrievalbf',
      component: () => import("@/components/紧缺人才目录/岗位查询检索备份"),
      meta: {
        title: '紧缺人才需求目录速查'
      }
    },
    {
      path: '/jqrcbf',
      name: 'jqrcbf',
      component: () => import("@/components/紧缺人才目录/紧缺人才目录城市备份"),
      meta: {
        title: '紧缺人才目录'
      }
    },
    {
      path: '/questionnaireJQ',
      name: 'questionnaireJQ',
      component: () => import("@/components/紧缺人才目录/问卷调查/问卷调查"),
      meta: {
        title: '问卷调查'
      }
    },
    {
      path: '/questionnaireJQ2024',
      name: 'questionnaireJQ2024',
      component: () => import("@/components/紧缺人才目录/问卷调查/问卷调查2024"),
      meta: {
        title: '问卷调查'
      }
    },
    {
      path: '/nanjinshi',
      name: 'nanjinshi',
      component: () => import("@/components/紧缺人才目录/城市/南京市"),
      meta: {
        title: '南京市紧缺人才目录'
      }
    },
    {
      path: '/jqxz',
      name: 'jqxz',
      component: () => import("@/components/紧缺人才目录/紧缺目录下载"),
      meta: {
        title: '南京市紧缺人才目录'
      }
    },
    {
      path: '/njgwxq',
      name: 'njgwxq',
      component: () => import("@/components/紧缺人才目录/城市/南京岗位详情"),
      meta: {
        title: '岗位详情'
      }
    },
    {
      path: '/suzhou16',
      name: 'suzhou16',
      component: () => import("@/components/紧缺人才目录/城市/苏州2016"),
      meta: {
        title: '2016年度苏州市重点产业紧缺人才需求目录'
      }
    },
    {
      path: '/suzhou17',
      name: 'suzhou17',
      component: () => import("@/components/紧缺人才目录/城市/苏州2017"),
      meta: {
        title: '2017年度苏州市重点产业紧缺人才需求目录'
      }
    },
    {
      path: '/suzhou18',
      name: 'suzhou18',
      component: () => import("@/components/紧缺人才目录/城市/苏州2018"),
      meta: {
        title: '2018年度苏州市重点产业紧缺人才需求目录'
      }
    },
    {
      path: '/suzhou2021',
      name: 'suzhou2021',
      component: () => import("@/components/紧缺人才目录/城市/苏州2021"),
      meta: {
        title: '2021年度苏州市重点产业紧缺人才需求目录'
      }
    },
    {
      path: '/suzhou2020',
      name: 'suzhou2020',
      component: () => import("@/components/紧缺人才目录/城市/苏州2020"),
      meta: {
        title: '2020年度苏州市重点产业紧缺人才需求目录'
      }
    },
    {
      path: '/caozhous2021',
      name: 'caozhous2021',
      component: () => import("@/components/紧缺人才目录/城市/潮州市2021"),
      meta: {
        title: '2021年度潮州市重点产业紧缺人才需求目录'
      }
    },
    {
      path: '/foss2021',
      name: 'foss2021',
      component: () => import("@/components/紧缺人才目录/城市/佛山市2021"),
      meta: {
        title: '2021年度佛山市重点产业紧缺人才需求目录'
      }
    },
    {
      path: '/dals2021',
      name: 'dals2021',
      component: () => import("@/components/紧缺人才目录/城市/大连市2021"),
      meta: {
        title: '2021年度大连市重点产业紧缺人才需求目录'
      }
    },
    {
      path: '/sahnghais2021',
      name: 'sahnghais2021',
      component: () => import("@/components/紧缺人才目录/城市/上海市2021"),
      meta: {
        title: '2021年度上海市重点产业紧缺人才需求目录'
      }
    },
    {
      path: '/xians2021',
      name: 'xians2021',
      component: () => import("@/components/紧缺人才目录/城市/西安市2021"),
      meta: {
        title: '2021年度西安市重点产业紧缺人才需求目录'
      }
    },
    {
      path: '/xians2020',
      name: 'xians2020',
      component: () => import("@/components/紧缺人才目录/城市/西安市2020"),
      meta: {
        title: '2020年度西安市重点产业紧缺人才需求目录'
      }
    },
    {
      path: '/shenys2021',
      name: 'shenys2021',
      component: () => import("@/components/紧缺人才目录/城市/沈阳2021"),
      meta: {
        title: '2021年度沈阳市重点产业紧缺人才需求目录'
      }
    },
    {
      path: '/xiamens2020',
      name: 'xiamens2020',
      component: () => import("@/components/紧缺人才目录/城市/厦门市2020"),
      meta: {
        title: '2020年度厦门市重点产业紧缺人才需求目录'
      }
    },
    {
      path: '/hangzhous2020',
      name: 'hangzhous2020',
      component: () => import("@/components/紧缺人才目录/城市/杭州市2020"),
      meta: {
        title: '2020年度杭州市重点产业紧缺人才需求目录'
      }
    },
    {
      path: '/suqians2021',
      name: 'suqians2021',
      component: () => import("@/components/紧缺人才目录/城市/宿迁市2021"),
      meta: {
        title: '2021年度宿迁市重点产业紧缺人才需求目录'
      }
    },
    {
      path: '/zhuhais2020_2021',
      name: 'zhuhais2020_2021',
      component: () => import("@/components/紧缺人才目录/城市/珠海2020_2021"),
      meta: {
        title: '珠海市重点产业紧缺人才需求目录'
      }
    },
    {
      path: '/hangzhous2021',
      name: 'hangzhous2021',
      component: () => import("@/components/紧缺人才目录/城市/杭州市2021"),
      meta: {
        title: '2021年度杭州市重点产业紧缺人才需求目录'
      }
    },
    {
      path: '/zhuhai17',
      name: 'zhuhai17',
      component: () => import("@/components/紧缺人才目录/城市/珠海2017"),
      meta: {
        title: '2017年珠海市紧缺人才开发目录'
      }
    },
    {
      path: '/dqx2022',
      name: 'dqx2022',
      component: () => import("@/components/紧缺人才目录/城市/德庆县2022"),
      meta: {
        title: '德庆县2022年引进紧缺人才需求目录'
      }
    },
    {
      path: '/jqs2022',
      name: 'jqs2022',
      component: () => import("@/components/紧缺人才目录/城市/嘉兴市2022"),
      meta: {
        title: '嘉兴市重点产业紧缺岗位人才目录（2022）'
      }
    },
    {
      path: '/jjs2022',
      name: 'jjs2022',
      component: () => import("@/components/紧缺人才目录/城市/靖江市2022"),
      meta: {
        title: '靖江市2022重点产业紧缺岗位人才目录'
      }
    },
    {
      path: '/tcs2022',
      name: 'tcs2022',
      component: () => import("@/components/紧缺人才目录/城市/铜川市2022"),
      meta: {
        title: '铜川市2022重点产业紧缺岗位人才目录'
      }
    },
    {
      path: '/xys2022',
      name: 'xys2022',
      component: () => import("@/components/紧缺人才目录/城市/信阳市2022"),
      meta: {
        title: '信阳市2022重点产业紧缺岗位人才目录'
      }
    },
    {
      path: '/zjk2022',
      name: 'zjk2022',
      component: () => import("@/components/紧缺人才目录/城市/张家口市2022"),
      meta: {
        title: '张家口市2022重点产业紧缺岗位人才目录'
      }
    },
    {
      path: '/fjs2022',
      name: 'fjs2022',
      component: () => import("@/components/紧缺人才目录/城市/福建省2022"),
      meta: {
        title: '福建省2021-2022重点产业紧缺岗位人才目录'
      }
    },
    {
      path: '/gzs2019',
      name: 'gzs2019',
      component: () => import("@/components/紧缺人才目录/城市/广州市2019"),
      meta: {
        title: '广州市2019重点产业紧缺岗位人才目录'
      }
    },
    {
      path: '/cds2011',
      name: 'cds2011',
      component: () => import("@/components/紧缺人才目录/城市/成都市2011"),
      meta: {
        title: '成都市2011重点产业紧缺岗位人才目录'
      }
    },
    {
      path: '/getLocation',
      name: 'getLocation',
      component: () => import("@/components/微信授权api/获取地理位置"),
      meta: {
        title: '位置授权'
      }
    },
    {
      path: '/questionnaireNew',
      name: 'questionnaireNew',
      component: () => import("@/components/大学生就业问卷调查推送/大学生问卷调查新"),
      meta: {
        title: '大学生问需调查'
      }
    },
    {
      path: '/postCount',
      name: 'postCount',
      component: () => import("@/components/大学生就业问卷调查推送/岗位计算结果"),
      meta: {
        title: '匹配结果详情'
      }
    },
    {
      path: '/postCountNJAPP',
      name: 'postCountNJAPP',
      component: () => import("@/components/大学生就业问卷调查推送/岗位计算结果南京大学生版APP"),
      meta: {
        title: '匹配结果详情'
      }
    },
    {
      path: '/pdfPreview',
      name: 'pdfPreview',
      component: () => import("@/components/紧缺人才目录/pdf预览.vue"),
      meta: {
        title: '预览'
      }
    },
    // {
    //   path: '/pdfPreviewcs',
    //   name: 'pdfPreviewcs',
    //   component: () => import("@/components/紧缺人才目录/预览.vue"),
    //   meta: {
    //     title: '预览'
    //   }
    // },
    {
      path: '/tobiaoys',
      name: 'tobiaoys',
      component: () => import("@/components/大学生就业问卷调查推送/test.vue"),
      meta: {
        title: '预览'
      }
    },
    {
      path: '/companyList',
      name: 'companyList',
      component: () => import("@/components/competition/机构列表.vue"),
      meta: {
        title: ''
      }
    },
    {
      path: '/cityCirclePC',
      name: 'cityCirclePC',
      component: () => import("@/components/大屏/都市圈大屏.vue"),
      meta: {
        title: '都市圈大屏'
      }
    },
    // {
    //   path: '/cityCirclePCcs',
    //   name: 'cityCirclePCcs',
    //   component: () => import("@/components/首页相关业务/contact/联系电话.vue"),
    //   meta: {
    //     title: '联系电话'
    //   }
    // },
    {
      path: '/serviceHall',
      name: 'serviceHall',
      component: () => import("@/components/首页相关业务/办事大厅.vue"),
      meta: {
        title: '办事大厅'
      }
    },
    {
      path: '/serviceHallNew',
      name: 'serviceHallNew',
      component: () => import("@/components/首页相关业务/办事大厅New.vue"),
      meta: {
        title: '办事大厅'
      }
    },
    {
      path: '/jobHuntEntry',
      name: 'jobHuntEntry',
      component: () => import("@/components/求职招聘/个人求职登记.vue"),
      meta: {
        title: '个人求职登记'
      }
    },
    {
      path: '/jobHuntEntryResult',
      name: 'jobHuntEntryResult',
      component: () => import("@/components/求职招聘/求职登记岗位结果.vue"),
      meta: {
        title: '招聘岗位'
      }
    },
    {
      path: '/jobHuntEntryResultTime',
      name: 'jobHuntEntryResultTime',
      component: () => import("@/components/求职招聘/定时推送求职登记岗位.vue"),
      meta: {
        title: '招聘岗位'
      }
    },
    {
      path: '/wxShare',
      name: 'wxShare',
      component: () => import("@/components/微信授权api/微信分享.vue"),
      meta: {
        title: '分享'
      }
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: () => import("@/components/系统公告/维护升级.vue"),
      meta: {
        title: '系统维护升级'
      }
    },
    {
      path: '/liveRecruitment',
      name: 'liveRecruitment',
      component: () => import("@/components/求职招聘/直播招聘.vue"),
      meta: {
        title: '直播活动'
      }
    },
    {
      path: '/dangAnReserve',
      name: 'dangAnReserve',
      component: () => import("@/components/档案预约服务/档案预约.vue"),
      meta: {
        title: '档案预约'
      }
    },
    {
      path: '/certification',
      name: 'certification',
      component: () => import("@/components/档案预约服务/出具证明.vue"),
      meta: {
        title: '出具证明'
      }
    },
    {
      path: '/readDang',
      name: 'readDang',
      component: () => import("@/components/档案预约服务/阅档.vue"),
      meta: {
        title: '阅档'
      }
    },
    {
      path: '/myReservation',
      name: 'myReservation',
      component: () => import("@/components/档案预约服务/预约列表.vue"),
      meta: {
        title: '我的预约'
      }
    },
    {
      path: '/cssq',
      name: 'cssq',
      component: () => import("@/components/求职招聘/测试授权.vue"),
      meta: {
        title: '测试授权'
      }
    },
    {
      path: '/arriveFirst',
      name: 'arriveFirst',
      component: () => import("@/components/人社服务包/一键通.vue"),
      meta: {
        title: '南京人社惠企政策一键通'
      }
    },
    {
      path: '/policy',
      name: 'policy',
      component: () => import("@/components/人社服务包/人社政策.vue"),
      meta: {
        title: '南京人社惠企政策一键通'
      }
    },
    {
      path: '/rsServe',
      name: 'rsServe',
      component: () => import("@/components/人社服务包/人社服务.vue"),
      meta: {
        title: '南京人社惠企政策一键通'
      }
    },
    {
      path: '/policyInfo',
      name: 'policyInfo',
      component: () => import("@/components/人社服务包/政策详情.vue"),
      meta: {
        title: '南京人社惠企政策一键通'
      }
    },
    {
      path: '/rsServeInfo',
      name: 'rsServeInfo',
      component: () => import("@/components/人社服务包/服务详情.vue"),
      meta: {
        title: '南京人社惠企政策一键通'
      }
    },
    {
      path: '/creative',
      name: 'creative',
      component: () => import("@/components/人社服务包/创企政策.vue"),
      meta: {
        title: '南京人社惠企政策一键通'
      }
    },
    {
      path: '/now',
      name: 'now',
      component: () => import("@/components/人社服务包/现企政策.vue"),
      meta: {
        title: '南京人社惠企政策一键通'
      }
    },
    {
      path: '/project',
      name: 'project',
      component: () => import("@/components/人社服务包/工企政策.vue"),
      meta: {
        title: '南京人社惠企政策一键通'
      }
    },
    {
      path: '/eat',
      name: 'eat',
      component: () => import("@/components/人社服务包/餐企政策.vue"),
      meta: {
        title: '南京人社惠企政策一键通'
      }
    },
    {
      path: '/middle',
      name: 'middle',
      component: () => import("@/components/人社服务包/中企政策.vue"),
      meta: {
        title: '南京人社惠企政策一键通'
      }
    },
    {
      path: '/arriveFirstQY',
      name: 'arriveFirstQY',
      component: () => import("@/components/人社服务包/企业一键通.vue"),
      meta: {
        title: '南京人社惠企政策一键通'
      }
    },
    {
      path: '/rsServeInfoCQ',
      name: 'rsServeInfoCQ',
      component: () => import("@/components/人社服务包/创企服务.vue"),
      meta: {
        title: '南京人社惠企政策一键通'
      }
    },
    {
      path: '/rsServeInfoXQ',
      name: 'rsServeInfoXQ',
      component: () => import("@/components/人社服务包/现企服务.vue"),
      meta: {
        title: '南京人社惠企政策一键通'
      }
    },
    {
      path: '/rsServeInfoGQ',
      name: 'rsServeInfoGQ',
      component: () => import("@/components/人社服务包/工企服务.vue"),
      meta: {
        title: '南京人社惠企政策一键通'
      }
    },
    {
      path: '/rsServeInfoEQ',
      name: 'rsServeInfoEQ',
      component: () => import("@/components/人社服务包/餐企服务.vue"),
      meta: {
        title: '南京人社惠企政策一键通'
      }
    },
    {
      path: '/rsServeInfoZQ',
      name: 'rsServeInfoZQ',
      component: () => import("@/components/人社服务包/中企服务.vue"),
      meta: {
        title: '南京人社惠企政策一键通'
      }
    },
    {
      path: '/reserveSuccess',
      name: 'reserveSuccess',
      component: () => import("@/components/档案预约服务/预约成功.vue"),
      meta: {
        title: '立即预约'
      }
    },
    {
      path: '/fileSearch',
      name: 'fileSearch',
      component: () => import("@/components/档案预约服务/档案查询.vue"),
      meta: {
        title: '档案查询'
      }
    },
    {
      path: '/reserveNow',
      name: 'reserveNow',
      component: () => import("@/components/档案预约服务/立即预约.vue"),
      meta: {
        title: '立即预约'
      }
    },
    {
      path: '/commonProblem',
      name: 'commonProblem',
      component: () => import("@/components/问题解答/常见问题.vue"),
      meta: {
        title: '常见问题'
      }
    },
    {
      path: '/answeringQuestions',
      name: 'answeringQuestions',
      component: () => import("@/components/问题解答/解答问题.vue"),
      meta: {
        title: '常见问题解答'
      }
    },
    ...eocs,
    ...newpages
  ]
})

router.beforeEach((to, form, next) => {
  /*路由变化修改title*/
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js